import { QueryClient } from "@tanstack/react-query";

/**
 * doc 27 §5: caching, dedup, invalidation and background refetch belong to
 * TanStack Query, not to hand-rolled effects.
 *
 * (H) Retries are conservative on purpose. A GET can be retried; a mutation
 * cannot be retried blindly, because a money write that is retried without a
 * did-it-land signal double-pays. Mutations therefore set `retry: 0` and each
 * one carries its own Idempotency-Key at the call site.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          const status = (error as { status?: number } | null)?.status;
          if (status !== undefined && status < 500 && status !== 429)
            return false;
          return failureCount < 2;
        },
      },
      mutations: { retry: 0 },
    },
  });
}
